import angular from 'angular';
import './tagIndicator.css';

export default angular
  .module('books.ui.tagIndicator', ['ui.bootstrap'])
  .directive('tagIndicator', tagIndicatorDirective).name;

tagIndicatorDirective.$inject = [];

/*******************************************************************************
 * Directive: tagIndicator */
/**
 * This renders an element which will display the tag indicator text against a
 * colored background. The background color is determined by the evaluation of
 * the displayAssigned expression. It is expected to have a boolean value returned
 * where the color will be set as follows:
 *  - Green            When true
 *  - Red              When false
 *  - Green and Red    When null/undefined. This is intended for product tag
 *                     management
 *
 * @attr {object}     tag              Tag model to display
 * @attr {expression} displayAssigned  Assigned tag indication. Used for bg color
 * @attr {tip}        expression       Optional expression for tooltip value
 *******************************************************************************/
/* @ngInject */ function tagIndicatorDirective() {
  return {
    restrict: 'E',
    template:
      '<div class="assignedBG"></div><div class="unassignedBG"></div>' +
      '<div class="indicator" ng-bind="tag.indicator" uib-tooltip="{{tip()}}" tooltip-trigger="mouseenter" tooltip-placement="right" tooltip-class="tagIndicatorTip"></div>',
    scope: { tag: '=', displayAssigned: '&', tip: '&' },
    link: function (scope, element) {
      /** Current indicator status class. */
      var mCurrentTagClass = null;

      /*-----------------------------------------*/
      /* Add watch to update the status class    */
      /* based on the displayAssigned expression */
      /*-----------------------------------------*/
      scope.$watch(
        function () {
          return scope.displayAssigned();
        },
        function (display) {
          /*----------------*/
          /* Remove current */
          /*----------------*/
          if (mCurrentTagClass) element.removeClass(mCurrentTagClass);

          /*-------------------------------------------------*/
          /* Set the appropriate status class based on the   */
          /* display value. If not provided, no class is set */
          /*-------------------------------------------------*/
          mCurrentTagClass =
            display != null && display != undefined
              ? display
                ? 'assigned'
                : 'unassigned'
              : null;

          /*----------------*/
          /* Add new if set */
          /*----------------*/
          if (mCurrentTagClass) element.addClass(mCurrentTagClass);
        }
      );
    }
  };
}
